// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#info-wrapper {
  overflow: auto;
}

.info-box {
  background-color: var(--white);
  box-shadow: var(--shadow);
  padding: 1rem;
  margin: 1rem 1rem 0;
}

.info-box h2 {
    margin: 0;
    padding: 0;
    font-size: 1.25rem;
  }

.info-box h3 {
    font-size: 1rem;
  }

#info {
  text-align: center;
}

.info-creators {
  display: inline-flex;
  flex-wrap: wrap;
  justify-content: center;
}

.info-creator {
  margin-left: 0.5rem;
  margin-right: 0.5rem;
}

#info-name {
  font-weight: bold;
  margin-top: 0.5rem;
}

#info-title {
  font-size: 0.75rem;
}

#info-mail {
  margin-top: 1rem;
}

.privacy-header {
  display: flex;
  margin-top: 1rem;
  margin-bottom: 0.5rem;
}

.privacy-header h3 {
    margin: 0 0 0 0.5rem;
    font-size: 1rem;
    line-height: 1.25rem;
  }
`, "",{"version":3,"sources":["webpack://./core/components/Info.css"],"names":[],"mappings":"AAAA;EACE,cAAc;AAChB;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;EACzB,aAAa;EACb,mBAAmB;AAWrB;;AATE;IACE,SAAS;IACT,UAAU;IACV,kBAAkB;EACpB;;AAEA;IACE,eAAe;EACjB;;AAGF;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,qBAAqB;AAOvB;;AALE;IACE,oBAAoB;IACpB,eAAe;IACf,oBAAoB;EACtB","sourcesContent":["#info-wrapper {\r\n  overflow: auto;\r\n}\r\n\r\n.info-box {\r\n  background-color: var(--white);\r\n  box-shadow: var(--shadow);\r\n  padding: 1rem;\r\n  margin: 1rem 1rem 0;\r\n\r\n  & h2 {\r\n    margin: 0;\r\n    padding: 0;\r\n    font-size: 1.25rem;\r\n  }\r\n\r\n  & h3 {\r\n    font-size: 1rem;\r\n  }\r\n}\r\n\r\n#info {\r\n  text-align: center;\r\n}\r\n\r\n.info-creators {\r\n  display: inline-flex;\r\n  flex-wrap: wrap;\r\n  justify-content: center;\r\n}\r\n\r\n.info-creator {\r\n  margin-left: 0.5rem;\r\n  margin-right: 0.5rem;\r\n}\r\n\r\n#info-name {\r\n  font-weight: bold;\r\n  margin-top: 0.5rem;\r\n}\r\n\r\n#info-title {\r\n  font-size: 0.75rem;\r\n}\r\n\r\n#info-mail {\r\n  margin-top: 1rem;\r\n}\r\n\r\n.privacy-header {\r\n  display: flex;\r\n  margin-top: 1rem;\r\n  margin-bottom: 0.5rem;\r\n\r\n  & h3 {\r\n    margin: 0 0 0 0.5rem;\r\n    font-size: 1rem;\r\n    line-height: 1.25rem;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
